import "./CeoMessage.css"

const CeoMessage = () => {
  return (
    <div>
      <div className="ceomessage" data-aos="fade-up"
        data-aos-duration="1000">
        <div className="ceomessage-img">
          <img src="/AboutPhotos/CeoMessage/CeoMessage.jpg" alt="" />
        </div>
        <div className="ceomessage-message">
          <h3>CHAIRMAN MESSAGE</h3>
          <h4>“We believe in the best!”</h4>
          <img src="/AboutPhotos/CeoMessage/chairmansignature.png" alt="" />
        </div>
      </div>
      <div className="ceomessage" data-aos="fade-up"
        data-aos-duration="1000">
        <div className="ceomessage-message">
          <h3>CEO's MESSAGE</h3>
          <h4>“We build places where your future grows!”</h4>
          <img src="/AboutPhotos/CeoMessage/ceosignature.png" alt="" />
        </div>
        <div className="ceomessage-img">
          <img src="/AboutPhotos/CeoMessage/CeoMessage2.jpeg" alt="" />
        </div>
      </div>
    </div>
  );
};

export default CeoMessage
